import React, { useState, useEffect } from 'react';
import './CookieConsent.css';
const CookieConsent = () => {
    const [isVisible, setIsVisible] = useState(false);
    useEffect(() => {
        const consent = localStorage.getItem('cookieConsent');
        if (!consent) {
            const timer = setTimeout(() => setIsVisible(true), 1500);
            return () => clearTimeout(timer);
        }
    }, []);
    const handleAccept = () => {
        localStorage.setItem('cookieConsent', 'true');
        setIsVisible(false);
    };
    if (!isVisible) return null;
    return (
        <div className="cookie-consent-banner">
            <div className="cookie-content">
                <span className="cookie-icon">🍪</span>
                <p>
                    Deneyiminizi geliştirmek ve çerezleri (kvkk/gdpr kapsamında) yönetmek için sitemizde çerezler kullanıyoruz.
                    Detaylı bilgi için <a href="/legal?tab=privacy" target="_blank">Gizlilik Politikası</a> sayfamızı inceleyebilirsiniz.
                </p>
            </div>
            <button className="cookie-accept-btn" onClick={handleAccept}>
                Kabul Et
            </button>
        </div>
    );
};
export default CookieConsent;
